import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { useCockpitExplorer } from '../hooks/useCockpitExplorer';

const CockpitOverviewPage = () => {
  const navigate = useNavigate();
  const { data, loading } = useCockpitExplorer();
  const zones = data?.zones || [];
  const controls = data?.controls || [];

  const viewIds = (zone) => zone.views.map((v) => v.id);
  const controlCount = (zone) => controls.filter((c) => viewIds(zone).includes(c.view)).length;

  return (
    <DashboardLayout>
      <div className="flex flex-col gap-6" data-testid="cockpit-overview-page">
        <div className="flex flex-col gap-2">
          <div
            className="font-plex-mono text-[13px] font-semibold tracking-[0.08em]"
            style={{ color: 'var(--gc-cyan)' }}
          >
            EXPLORE THE COCKPIT
          </div>
          <h1
            className="font-barlow-condensed font-bold text-4xl sm:text-5xl lg:text-6xl leading-none m-0"
            style={{ color: 'var(--gc-text-main)' }}
          >
            The Fenix A320 flight deck
          </h1>
          <p className="text-base max-w-2xl" style={{ color: 'var(--gc-text-body)' }}>
            Pick a zone. The key controls are marked on the real panel, with what each one does and the phase where you'll use it.
          </p>
        </div>

        <div
          className="w-full rounded-gc-card border overflow-hidden"
          style={{ borderColor: 'var(--gc-border-card)' }}
          data-testid="cockpit-hero-banner"
        >
          <img src="/cockpit/hero.jpg" alt="Fenix A320 flight deck" className="w-full h-auto block" />
        </div>

        {!loading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="cockpit-zone-cards">
            {zones.map((zone) => (
              <button
                key={zone.id}
                type="button"
                onClick={() => navigate(`/cockpit/${zone.id}`)}
                className="flex flex-col gap-1.5 p-4 rounded-gc-card border cursor-pointer text-left transition-colors hover:border-glass-cyan"
                style={{ background: 'var(--gc-checklist-card)', borderColor: 'var(--gc-border-card)' }}
                data-testid={`cockpit-zone-card-${zone.id}`}
              >
                <div className="flex items-baseline justify-between gap-2">
                  <span
                    className="font-barlow-condensed font-bold text-xl"
                    style={{ color: 'var(--gc-text-main)' }}
                  >
                    {zone.name}
                  </span>
                  <span
                    className="font-plex-mono text-[11px] font-semibold tracking-[0.06em] whitespace-nowrap"
                    style={{ color: 'var(--gc-text-muted)' }}
                  >
                    {controlCount(zone)} CONTROLS
                  </span>
                </div>
                <p className="text-sm text-left" style={{ color: 'var(--gc-text-body)' }}>
                  {zone.blurb}
                </p>
                <span
                  className="inline-flex items-center gap-1.5 font-barlow-condensed font-semibold text-sm mt-1"
                  style={{ color: 'var(--gc-cyan)' }}
                >
                  Explore <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default CockpitOverviewPage;
